export default __webpack_public_path__ + "static/media/aakashlogo-white.1603c88c.svg";